import { BaseRouteService } from 'core/services';

class FulfillmentUserRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-users';
	}

	validateEmail(email) {
		return super.get(`${this.base}/validate-email/{email}`, null, { email });
	}
}

export default FulfillmentUserRouteService;
